import Modal from './guard-modal'
import Route from './guard-route'

const Guard = {
  Modal,
  Route,
}

export default Guard
